import React from 'react';

import { nudgeIconFill, nudgeTextColor } from '@lyearn/form/src/Form/styles';
import { AlertCircle, SparkleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { QuizCreatorQuestionError } from '@/modules/corporate/modules/quiz/views/QuizEditor/hooks/useQuizEditor/types';

export const QuestionError = ({
  error,
  className,
}: {
  error?: QuizCreatorQuestionError;
  className?: string;
}) => {
  const isNudgeError = error?.type === 'LyearnAINudge';

  const icon = isNudgeError ? (
    <SparkleOutline className={cn('h-16 w-16', nudgeIconFill)} />
  ) : (
    <AlertCircle className="h-16 w-16" fillColorToken="icon-error" />
  );

  return (
    <Stack
      alignItems="center"
      className={cn('mb-16 h-22 px-12', className, { 'opacity-0': !error })}
      gapX={6}>
      {icon}
      <Typography
        className={isNudgeError ? nudgeTextColor : undefined}
        color="text-text-error"
        variant="body-short-02">
        {error?.message}
      </Typography>
    </Stack>
  );
};
